module.exports = __webpack_public_path__ + "static/media/yanwen.01b363a3.svg";